<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="分配单号">
                <a-input v-model="queryParam.allocationNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="1"> 有效 </a-select-option>
                  <a-select-option :value="2"> 已过期 </a-select-option>
                  <a-select-option :value="3"> 已用完 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime" />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <template>
          <a-button
            type="primary"
            @click="handleExport"
            v-hasPermi="['9ea4ec2db8bbf66a9765f5ea0957e00fe:0:e']"
          >
            导出
          </a-button>
        </template>
      </div>
      <CreateForm ref="CreateForm" @ok="getList" :userList="userList"></CreateForm>

      <DetailDrawer ref="detailDrawer" />

      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        class="center-table">
        <span slot="allocationNo" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.allocationNo">
            <span class="text-ellipsis">{{ record.allocationNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="agentTenantName" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.agentTenantName">
            <span class="text-ellipsis">{{ record.agentTenantName || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="capacityUsage" slot-scope="text, record">
          <div class="capacity-container">
            <div class="capacity-progress">
              <div
                class="progress-bar"
                :style="{ width: getUsageRate(record) + '%', backgroundColor: getProgressColor(record) }"
              ></div>
            </div>
            <div class="capacity-text">
              {{ $formatCapacity(record.usedCapacity) }}/{{ $formatCapacity(record.allocateCapacity) }}
            </div>
          </div>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="getStatusColor(record.status)">
            {{
              record.status == 1 ? '有效' : record.status == 2 ? '已过期' : record.status == 3 ? '已用完' : '已回收'
            }}
          </a-tag>
        </span>
        <span slot="expireTime" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.expireTime">
            <span class="text-ellipsis">{{ record.expireTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.createTime">
            <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <div class="action-right">
            <a @click="handleDetail(record)" v-hasPermi="['9ea4ec2db8bbf66a9765f5ea0957e00fq:0:q']">详情</a>
          </div>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj } from '@/api/VR/assignAgents'
import CreateForm from './modules/CreateForm.vue'
import DetailDrawer from './modules/DetailDrawer.vue'
import { listTenant } from '@/api/system/tenant'
import { tableMixin } from '@/store/table-mixin'
import parameter from '@/mixins/parameter'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { download } from '@/utils/requestVr'
export default {
  name: 'Work',
  components: {
    CreateForm,
    DetailDrawer,
  },
  mixins: [tableMixin, parameter],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      value: [],
      advanced: false,
      loading: false,
      selectedRowKeys: [],
      userList: [],
      columns: [
        {
          title: '分配单号',
          dataIndex: 'allocationNo',
          key: 'allocationNo',
          width:'15%',
          align: 'center',
          scopedSlots: { customRender: 'allocationNo' },
        },
        {
          title: '接收方代理名称',
          dataIndex: 'agentTenantName',
          key: 'agentTenantName',
          align: 'center',
          scopedSlots: { customRender: 'agentTenantName' },
        },
        {
          title: '容量使用情况',
          width: 160,
          dataIndex: 'allocateCapacity',
          key: 'allocateCapacity',
          align: 'center',
          scopedSlots: { customRender: 'capacityUsage' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '过期时间',
          dataIndex: 'expireTime',
          align: 'center',
          scopedSlots: { customRender: 'expireTime' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' },
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  methods: {
    handleDetail(record) {
      this.$refs.detailDrawer.show(record)
    },

    getStatusColor(status) {
      const colorMap = {
        1: 'green',
        2: 'orange',
        3: 'blue',
        4: 'red',
      }
      return colorMap[status] || 'default'
    },

    // 获取使用率
    getUsageRate(record) {
      if (!record.allocateCapacity || record.allocateCapacity === 0) return 0
      const rate = ((record.usedCapacity || 0) / record.allocateCapacity) * 100
      return Math.min(100, Math.max(0, rate.toFixed(1)))
    },

    // 获取进度条颜色
    getProgressColor(record) {
      const rate = this.getUsageRate(record)
      if (rate >= 90) return '#ff4d4f'
      if (rate >= 70) return '#faad14'
      return '#52c41a'
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    getQi() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 1,
        status: 0,
      }
      listTenant(query).then((res) => {
        this.userList = res.data.records
      })
    },
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        allocationNo: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
         download(
            'vr/storage/enterprise/temp/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
    onChangeTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    if (this.userType == 0) {
    }
    this.getList()
  },
}
</script>

<style>
.table-operations {
  margin-bottom: 16px;
}

.table-operations .ant-btn {
  margin-right: 8px;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: right;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper .ant-form-item {
  margin-bottom: 16px;
}

.center-table .ant-table-thead > tr > th {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-tbody > tr > td {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-thead > tr > th,
.center-table .ant-table-tbody > tr > td {
  vertical-align: middle;
}

.center-table .ant-dropdown-link {
  display: inline-block;
}

.ant-table-pagination {
  text-align: center;
}

.center-table {
  width: 100%;
}

.center-table .ant-table-container {
  width: 100%;
}

.center-table .ant-table-content {
  text-align: center;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

/* 统一容量使用情况样式 */
.capacity-container {
  width: 100%;
}

.capacity-progress {
  width: 100%;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.progress-bar {
  height: 100%;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.capacity-text {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}
</style>
